import axios from "axios";
import { Base_URL } from "../url";

export const fetchValuationMethods = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ValuationMethod/GetAllValuationMethods`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching valuation methods!";
  }
};

export const downloadValuationMethodsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/ValuationMethod/DownloadValuationMethodsExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading valuation methods data!";
  }
};